import TaxAuthorityTable from './TaxAuthorityTable';

export default TaxAuthorityTable;
